<!-- Runmode:milestone用のコンポーネント -->
<template>
  <div class="root">
    <PinchInQue v-show="isShowPinchInQue" :pinchInText="pinchInText" :pathstep="pathstep" :pinchInShowVoice="false" @pinchOut="recievePinchOut" />
    <PinchInActStore />
    <div class="page-content">
      <div class="inner flexrow milestone">
        <div class="toparea-group">
          <!-- 音声認識ON -->
          <div class="toparea-mic">
            <div class="flexcenter" v-show="showSre">
              <div id="inputarea" class="item bgdgray bdgreen w300" :class="{ textmgray: isTextGrayStyle }">
                <div class="inputarea-speech">{{ sreResponseText }}</div>
                <div class="mic-icon" :class="scoreStyle"></div>
              </div>
              <div class="icon-skip" :class="{ disabled: disableSkipSre }" @click="skipSreQuestion"></div>
            </div>
          </div>
          <!-- 音声認識OFF -->
          <div class="toparea-text">
            <div class="flexstretch" v-show="showTile">
              <div v-for="(answer, index) in selectAnswers" :key="index"
                   :id="'choice_list_' + index" :class="['item w200', isMobile() ? '' : getTextFontClassTile(answer.text, productLanguage)]"
                   @click="clickAnswer(index)"
                   @touchstart="onTouchStart(selectAnswersTexts[answer.confuserIndex][answer.confuserChildIndex])"
                   @touchend="onTouchEnd()"
                   @touchmove="onTouchEnd()"
                   @mousedown="$emit('hintMouseDown', $event)"
                   @mouseup="$emit('hintMouseUp', $event)"
                   @mousemove="$emit('hintMouseMove', $event)">
                <span v-html="getPopupTextElem(selectAnswersTexts[answer.confuserIndex][answer.confuserChildIndex])"></span>
                <button v-show="showPinchInBtn" class="icon-pinch-in" @click="clickPinchInQue(selectAnswersTexts[answer.confuserIndex][answer.confuserChildIndex])"></button>
              </div>
            </div>
          </div>
        </div>

        <!-- カード -->
        <div class="cards-container">
          <div class="swiper-milestone swiper-container">
            <div class="card-inner card-voice swiper-wrapper" :style="tileStyles">
              <template v-for="(group, groupIndex) in actSwiper.group">
                <div class="swiper-slide" :key="groupIndex">
                  <div v-if="group.act.length == 1">
                    <div class="card-single flexcenter">
                      <MilestoneAct :act="group.act[0]"
                        :productLanguage="productLanguage"
                        :scriptSystems="scriptSystems"
                        :presentActIndex="currentActIndex"
                        :currentConfuserIndex="currentConfuserIndex"
                        :answerState="answerState"
                        :showAnswer="showAnswer"
                        :showPinchInBtn="showPinchInBtn"
                        :mode="pathstep.mode"
                        :questionState="questionState"
                        @childAudioPlay="childAudioPlay" />
                    </div>
                  </div>
                  <div v-else>
                    <div class="card-multi flexcenter">
                      <div v-for="(act, actIndex) in group.act" :key="actIndex">
                        <MilestoneAct :act="act"
                          :productLanguage="productLanguage"
                          :scriptSystems="scriptSystems"
                          :presentActIndex="currentActIndex"
                          :currentConfuserIndex="currentConfuserIndex"
                          :answerState="answerState"
                          :showAnswer="showAnswer"
                          :showPinchInBtn="showPinchInBtn"
                          :pathstepMode="pathstep.mode"
                          :questionState="questionState"
                          @childAudioPlay="childAudioPlay" />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>

    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";

import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";

import MilestoneAct from "./MilestoneAct";
import PinchInQue from "./PinchInQue";
import PinchInActStore from "./PinchInActStore";

/**
 * 出題中actのstate
 */
// スライド中
const QUESTION_STATE_INIT = "init";
// 出題時の音声再生
const QUESTION_STATE_INIT_AUDUO = "initAudio";
// 出題中
const QUESTION_STATE_START = "start";
// 音声再生ボタンで再生中
const QUESTION_STATE_START_AUDIO = "startAudio";
// 一時停止
const QUESTION_STATE_PAUSE = "pause";
// 終了
const QUESTION_STATE_END = "end";
// 正解時の音声再生
const QUESTION_STATE_END_AUDIO = "endAudio";

/**
 * CSSのクラス名
 */
const CLASS_NAME_SCORE = "score_";

export default {
  name: "Milestone",
  props: {
    pathstep: Object,
    productLanguage: String,
    scriptSystems: Object
  },
  mixins: [
    common,
    runmode,
    audio,
    constants,
    storeConstants
  ],
  components: {
    MilestoneAct,
    PinchInQue,
    PinchInActStore
  },
  computed: {
    ...mapGetters([
      "showAllAnswer"
    ]),
    /**
     * ピンチインAct表示
     * @returns {default.computed.$store.getters.showPinchIn}
     */
    showPinchInAct: function() {
      return this.$store.getters.showPinchIn;
    },
    /**
     * ピンチイン音声再生Index
     * @returns {default.computed.$store.getters.pinchInAudioPlayActIndex}
     */
    pinchInAudioPlayActIndex: function() {
      return this.$store.getters.pinchInAudioPlayActIndex;
    },
    autoAdjustSelector: function() {
      return {
        type: this.sreUse == "true" ? ".active-type2" : ".active-type3",
        area: this.sreUse == "true" ? "p" : ".select"
      };
    }
  },
  data: function() {
    return {
      // スライダー
      swiper: null,
      // スライド中はtrue
      isSwiperAnimating: false,
      // swiperが初期化済みの場合true
      isInitSwiper: false,
      // スライダー表示用
      actSwiper: null,
      // グループ管理用
      actGroupIndex: null,
      // 出題中actのindex
      currentActIndex: -1,
      // 出題中actのstate
      questionState: QUESTION_STATE_INIT,
      // 出題中act以外が音声再生中の場合true
      isActAudioPlay: false,
      // 音声認識off時の出題中actの回答状態(出題中: -1、正解: 1、不正解: 0)
      answerState: -1,
      showAnswer: false,
      timeoutid: null,
      incorrectCount: 0,
      // 表示管理
      showSre: false,
      showTile: false,
      // SRE関連
      sreResponseText: "",
      isTextGrayStyle: true,
      scoreStyle: "",
      disableSkipSre: true,
      isListenForPhrasesUpdate: false,
      isSreSkip: false,
      isGoGroup: false,
      sreTimeoutCount: 0,
      // 選択肢関連
      selectAnswers: [],
      selectAnswersTexts: [],
      currentConfuserIndex: -1,
      // 選択肢の拡大表示フラグ
      isShowPinchInQue: false,
      // 拡大表示テキスト
      pinchInText: "",
      // 問題音声
      showQestionVoice: false,
      // 拡大ボタン表示
      showPinchInBtn: false,
      // タッチイベント長押しタイマー
      touchTimer: null
    };
  },
  methods: {
    /**
     * 音声認識を開始
     */
    listenForPhrases: function() {
      this.log("Milestone start listenForPhrases");

      this.setShowInitSre();
      this.showAnswer = false;

      var callbacks = {
        start: this.lfpStart,
        update: this.lfpUpdate,
        error: this.lfpError,
        interrupting: this.lfpInterrupting,
        success: this.lfpSuccess,
        end: this.lfpEnd
      };

      var act = this.pathstep.acts[this.currentActIndex];
      var phrases = this.getBasicTextByScriptid(act, this.scriptSystems.speech);

      this.log("Milestone listenForPhrases: " + phrases);
      sonic_wrapper.listenForPhrases([phrases], callbacks);
    },
    /**
     * 音声認識を停止
     */
    listenForPhrasesStop: function() {
      if (sonic_wrapper.isSessionRunning()) {
        this.log("Milestone start listenForPhrasesStop");
        sonic_wrapper.interruptSession();
      }
    },
    /**
     * 音声認識startイベント
     */
    lfpStart() {
      this.log("Milestone start lfpStart");
      this.isListenForPhrasesUpdate = false;
    },
    /**
     * 音声認識updateイベント
     */
    lfpUpdate() {
      this.log("Milestone start lfpUpdate");

      this.isListenForPhrasesUpdate = true;
      if (sonic_wrapper.hasLfpHypothesisResponse()) {
        var response = sonic_wrapper.getLfpResponse();
        this.sreResponseText = response;
        this.log("lfpUpdate: " + response);
      }
    },
    /**
     * 音声認識errorイベント
     */
    lfpError() {
      this.log("Milestone start lfpError");
    },
    /**
     * 音声認識interruptingイベント
     */
    lfpInterrupting() {
      this.log("Milestone start lfpInterrupting");
    },
    /**
     * 音声認識successイベント
     */
    lfpSuccess() {
      this.log("Milestone start lfpSuccess");
    },
    /**
     * 音声認識endイベント
     */
    lfpEnd() {
      this.log("Milestone start lfpEnd");

      // interruptSession()で音声認識を停止した場合
      if (sonic_wrapper.isStopReasonManual()) {
        // スキップボタン押下時
        if (this.isSreSkip) {
          this.isSreSkip = false;
          this.nextQuestion(true);
          return;
        }

        // 次の問題へボタン押下時
        if (this.isGoGroup) {
          this.isGoGroup = false;
          this.goNextGroup();
          return;
        }

        return;
      }

      if (!sonic_wrapper.isCalibrationResultOk()) {
        // タイムアウト
        this.sreTimeoutCount++;
        if (this.sreTimeoutCount >= 2) {
          // タイムアウトが2回連続発生
          this.sreTimeoutCount = 0;
          this.$emit("showMicrophoneErrorDialog");
        } else {
          // 再挑戦
          var self = this;
          this.timeoutid = setTimeout(function() {
            self.listenForPhrases();
          }, constants.QUESTION_INTERVAL);
        }
      } else if (!this.isListenForPhrasesUpdate) {
        // マイク未接続
        this.incorrectCount = 0;
        this.$emit("showMicrophoneErrorDialog");
      } else {
        this.sonicTimeoutCount = 0;
        if (!sonic_wrapper.isStopReasonManual()) {
          // 中断でない場合
          this.checkAnswer();
        }
      }
    },
    checkAnswer: function() {
      this.log("Milestone start checkAnswer");

      // 音声認識のスコア
      var score = 0;
      if (sonic_wrapper.hasLfpHypothesisScore()) {
        score = sonic_wrapper.getLfpScore();
      }
      this.log("sre score: " + score);

      this.scoreStyle = CLASS_NAME_SCORE + String(score);

      if (sonic_wrapper.getLfpPassed()) {
        // 正解
        this.log("sre passed: true");
        this.questionState = QUESTION_STATE_END;

        // 正解音の再生
        this.audioCorrect();

        var act = this.pathstep.acts[this.currentActIndex];

        // 正解文取得
        var obj = this.getTextObj(act);
        var phrases = obj.textObj.basicText;

        this.isTextGrayStyle = false;
        this.sreResponseText = this.tagErase(phrases);
        this.disableSkipSre = true;

        // 2回連続不正解していない場合、スコア更新
        if (this.incorrectCount < 2) {
          this.setActState(true);
        }

        var self = this;
        this.timeoutid = setTimeout(function() {
          // 正解表示、音声再生
          self.questionState = QUESTION_STATE_END_AUDIO;
          self.showAnswer = true;
          self.audioPlay(act.sounds[0]);
        }, constants.INCORRECT_INTERVAL);
      } else {
        // 不正解
        this.log("sre passed: false");
        var self = this;

        // 不正解音の再生
        this.audioInCorrect();

        this.incorrectCount++;

        // 2回連続不正解の場合、スコア更新
        if (this.incorrectCount == 2) {
          this.setActState(false);

          var act = this.pathstep.acts[this.currentActIndex];
          if (act.textPolicy === "r") {
            // テキスト、再生ボタン表示
            this.showAnswer = true;
          }

          this.timeoutid = setTimeout(function() {
            self.questionState = QUESTION_STATE_START_AUDIO;
            self.audioPlay(act.sounds[0]);
          }, constants.INCORRECT_INTERVAL);
          return;
        }

        // 再挑戦
        this.timeoutid = setTimeout(function() {
          self.listenForPhrases();
        }, constants.INCORRECT_INTERVAL);
      }
    },
    /**
     * 選択肢の押下処理
     */
    clickAnswer: function(index) {
      this.log("Milestone start clickAnswer");

      if (this.isAudioPlaying) {
        return;
      }

      // 選択肢の拡大表示中は、何もしない
      if (this.isShowPinchInQue) {
        return;
      }

      if (this.answerState != -1) {
        return;
      }

      var self = this;
      if (this.selectAnswers[index].correct) {
        this.answerState = 1;

        // 全て出題したか確認
        var act = this.pathstep.acts[this.currentActIndex];
        var textInfo = act.texts[0];
        if (textInfo.confusers.length == this.currentConfuserIndex + 1) {
          // 正解音の再生
          this.questionState = QUESTION_STATE_END;
          this.audioCorrect();

          // スコア更新
          if (this.incorrectCount == 0) {
            this.setActState(true);
          }

          this.timeoutid = setTimeout(function() {
            // 音声再生
            self.answerState = -1;
            self.questionState = QUESTION_STATE_END_AUDIO;
            self.audioPlay(act.sounds[0]);
          }, constants.INCORRECT_INTERVAL);
        } else {
          // 次の空所へ
          this.timeoutid = setTimeout(function() {
            self.answerState = -1;
            self.createSelectAnswers(self.currentConfuserIndex + 1);
          }, constants.QUESTION_INTERVAL);
        }
      } else {
        this.answerState = 0;

        // スコア更新
        if (this.incorrectCount == 0) {
          this.setActState(false);
        }
        this.incorrectCount++;

        // 不正解音の再生
        this.audioInCorrect();

        var self = this;
        this.timeoutid = setTimeout(function() {
          self.answerState = -1;
        }, constants.QUESTION_INTERVAL);
      }
    },
    /**
     * スライダー表示用のグループ分け
     */
    createGroupForSwiper: function() {
      this.log("Milestone start createGroupForSwiper");

      var acts = this.pathstep.acts;
      var groupIndex = 0;
      this.actSwiper = { group: [] };
      this.actGroupIndex = { index: [] };

      for (var i = 0; i < acts.length; i++) {
        var obj = { act: [] };
        var skipObj = { group: groupIndex };

        // 最後か確認
        if (i + 1 == acts.length) {
          obj.act.push(this.addActIndex(i));
        } else {
          if (acts[i].usage == -1) {
            obj.act.push(this.addActIndex(i));

            // 次のactを確認
            if (acts[i + 1].usage != -1) {
              groupIndex++;
            }
          } else {
            // 次のactを確認
            if (acts[i + 1].usage == -1) {
              obj.act.push(this.addActIndex(i));
              groupIndex++;
            } else {
              obj.act.push(this.addActIndex(i));
              obj.act.push(this.addActIndex(i + 1));
              this.actGroupIndex.index.push(skipObj);

              groupIndex++;
              i++;
            }
          }
        }

        this.actSwiper.group.push(obj);
        this.actGroupIndex.index.push(skipObj);
      }

      var groupLen = this.actGroupIndex.index[this.pathstep.acts.length - 1].group + 1;
      var swiperLen = this.actSwiper.group.length;
      this.log("group count: " + groupLen + ", swiper count: " + swiperLen);

      this.$store.dispatch("setMilestoneGroupLength", groupLen);
      this.$store.dispatch("setMilestoneGroupIndex", 1);
    },
    /**
     *
     */
    addActIndex: function(index) {
      var val = this.pathstep.acts[index];
      val.index = index;
      return val;
    },
    /**
     * Swiperの初期化
     */
    initSwiper: function() {
      this.log("Milestone start initSwiper");

      var self = this;

      var spaceBetween = 0;
      if (this.isEnvironmentPc()) {
        spaceBetween = 30;
      }

      // スライダーの準備
      this.swiper = new Swiper(".swiper-milestone", {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: spaceBetween,
        speed: 1500,
        simulateTouch: false,
        shortSwipes: false,
        longSwipes: false,
        allowTouchMove: false,
        initialSlide: 0,
        on: {
          init: function() {
            self.isInitSwiper = true;

            if (self.lessonState === storeConstants.LESSON_STATE_START) {
              // 出題開始
              self.question(0);
            }
          },
          slideNextTransitionEnd: function() {
            self.log("Milestone start slideNextTransitionEnd");

            // 次の問題を開始
            self.timeoutid = setTimeout(function() {
              self.isSwiperAnimating = false;
              self.question(self.currentActIndex + 1);
            }, constants.QUESTION_INTERVAL);
          }
        }
      });
    },
    /**
     * 発音スコア表示か選択肢表示かを設定
     */
    setShowAnswer: function(sre, index) {
      this.showSre = false;
      this.showTile = false;

      var act = this.pathstep.acts[index];
      if (act.usage == 1) {
        if (sre === "true") {
          this.setShowInitSre();
          this.showSre = true;
        } else {
          this.showTile = true;
        }
      }
    },
    /**
     * 発音スコア表示を初期化
     */
    setShowInitSre: function() {
      this.scoreStyle = CLASS_NAME_SCORE + "0";
      this.isTextGrayStyle = true;
      this.disableSkipSre = false;
      this.sreResponseText = "";
    },
    /**
     * スライド移動
     */
    slideSwiper: function(index) {
      this.log("Milestone start slideSwiper: " + index);

      this.isSwiperAnimating = true;

      // 最後のスライドの場合
      if (this.actSwiper.group.length - 1 == index) {
        this.$parent.goDisabled = false;
      }

      this.swiper.slideTo(index);
    },
    /**
     * 出題開始
     */
    question: function(actIndex) {
      this.log("Milestone start question: " + actIndex);

      this.currentActIndex = actIndex;

      var now = this.actGroupIndex.index[this.currentActIndex].group;
      this.$store.dispatch("setMilestoneGroupIndex", now + 1);

      if (this.questionState === QUESTION_STATE_PAUSE) {
        return;
      }

      this.setShowAnswer(this.sreUse, actIndex);
      var act = this.pathstep.acts[actIndex];
      var play = false;
      if (act.usage == 1) {
        if (act.textPolicy != "r") {
          play = true;
        } else {
          // 音声認識OFFでかつ、空所がない場合
          if (this.sreUse === "false" && !this.isTileText()) {
            play = true;
          }
        }
      } else {
        play = true;
      }

      // 選択肢の作成
      this.createSelectAnswers(0);

      if (play) {
        // 音声再生
        this.questionState = QUESTION_STATE_INIT_AUDUO;
        this.audioPlay(act.sounds[0]);
      } else {
        this.questionState = QUESTION_STATE_START;
        this.incorrectCount = 0;
        if (this.sreUse === "true") {
          // 音声認識を開始
          this.listenForPhrases();
        }
      }
    },
    /**
     * 次の問題を開始
     */
    nextQuestion: function(swiperCheck) {
      this.log("Milestone start nextQuestion: " + swiperCheck);

      this.showSre = false;
      this.showTile = false;

      // 全て出題済みか確認
      if (this.pathstep.actNum == this.currentActIndex + 1) {
        this.$emit("endAct");
        return;
      }

      this.questionState = QUESTION_STATE_INIT;

      if (swiperCheck) {
        // スライドが必要か確認
        var now = this.actGroupIndex.index[this.currentActIndex].group;
        var next = this.actGroupIndex.index[this.currentActIndex + 1].group;
        if (now == next) {
          // 次の問題を開始
          var self = this;
          this.timeoutid = setTimeout(function() {
            self.question(self.currentActIndex + 1);
          }, 1000);

          return;
        }
      }

      // 次のactへスライド
      var index = this.swiper.activeIndex + 1;
      this.slideSwiper(index);
    },
    /**
     * 再開
     */
    restartQuestion: function() {
      this.log("Milestone start restartQuestion");

      this.questionState = QUESTION_STATE_START;
      var act = this.pathstep.acts[this.currentActIndex];
      if (act.usage == 1) {
        if (this.sreUse === "true") {
          // 音声認識を開始
          this.showSre = true;
          this.listenForPhrases();
        } else {
          this.showTile = true;
        }
      } else {
        this.question(this.currentActIndex);
      }
    },
    /**
     * 空所があるか確認
     */
    isTileText: function() {
      var act = this.pathstep.acts[this.currentActIndex];
      var str = act.texts[0].tileText;

      if (str.length == 0) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 選択肢のリストを作成
     */
    createSelectAnswers: function(confuserIndex) {
      var act = this.pathstep.acts[this.currentActIndex];

      this.selectAnswers.splice(0);

      var textInfo = act.texts[0];
      var confusers = textInfo.confusers;
      if (textInfo.confusers.length != 0) {
        this.currentConfuserIndex = confuserIndex;
        var val = textInfo.confusers[confuserIndex];
        for (var i = 0; i < val.length; i++) {
          var data = { text: val[i].text, correct: val[i].correct, confuserIndex: confuserIndex, confuserChildIndex: i };
          this.selectAnswers.push(data);
        }

        // ランダムに順序を入れ替え
        this.selectAnswers = _.shuffle(this.selectAnswers);

        // 表示用テキスト一覧生成
        this.createSelectAnswerTexts(confuserIndex);
      }
    },
    /**
     * 選択肢表示テキスト一覧取得
     */
    createSelectAnswerTexts: function(confuserIndex) {
      this.log("Milestone start createSelectAnswerTexts");

      this.selectAnswersTexts = [];

      var act = this.pathstep.acts[this.currentActIndex];
      // テキストオブジェクト取得
      var obj = this.getTextObj(act);
      var confusers = obj.textObj.confusers;
      var pinyin = obj.pinyin;
      var result = [];

      if (confusers.length != 0 && confusers[confuserIndex]) {
        for (let i = 0; i < confusers[confuserIndex].length; i++) {
          var text = confusers[confuserIndex][i].text.replace(/(,|\.|\?)/g, "");
          if (pinyin && pinyin.confusers[confuserIndex][i]) {
            // ピンイン表示
            text = this.getChineseTextWithPinyin(text, pinyin.confusers[confuserIndex][i].text);
          }
          if (obj.kana) {
            // ふりがな表示
            text = this.getJapaneseTextWithKana(text, confusers[confuserIndex][i].superScripts);
          }
          result[i] = text;
        }
      }
      this.selectAnswersTexts[confuserIndex] = result;
    },
    /**
     * 音声認識をスキップ
     */
    skipSreQuestion: function() {
      this.log("Milestone start skipSreQuestion");

      switch (this.questionState) {
        case QUESTION_STATE_START:
        case QUESTION_STATE_START_AUDIO:
          this.showSre = false;
          this.showTile = false;

          this.questionState = QUESTION_STATE_END;
          this.isSreSkip = true;
          this.audioPause();

          if (sonic_wrapper.isSessionRunning()) {
            this.listenForPhrasesStop();
          } else {
            this.isSreSkip = false;
            this.nextQuestion(true);
          }

          break;
        default:
          break;
      }
    },
    /**
     * 次の問題へボタン押下時の処理
     */
    goGroup: function() {
      this.log("Milestone start goGroup");

      // 全解答表示中は何もしない
      if (this.showAllAnswer) {
        return;
      }

      switch (this.questionState) {
        case QUESTION_STATE_START:
        case QUESTION_STATE_START_AUDIO:
          this.showSre = false;
          this.showTile = false;

          this.questionState = QUESTION_STATE_END;
          this.isGoGroup = true;
          this.audioPause();

          if (sonic_wrapper.isSessionRunning()) {
            this.listenForPhrasesStop();
          } else {
            this.isGoGroup = false;
            this.goNextGroup();
          }
          break;
        default:
          break;
      }
    },
    /**
     * 次のグループへ移動
     */
    goNextGroup: function() {
      this.log("Milestone start goNextGroup");

      // currentActIndexを、次に出題するactの1つ前のものにする
      var now = this.swiper.activeIndex;
      var group = this.actSwiper.group[now];
      var len = group.act.length;
      if (len == 1) {
        this.currentActIndex = group.act[0].index;
      } else {
        this.currentActIndex = group.act[len - 1].index;
      }

      this.slideSwiper(now + 1);
    },
    /**
     * 音声再生
     */
    childAudioPlay: function(sound, index) {
      // スライド中は何もしない
      if (this.isSwiperAnimating) {
        return;
      }

      switch (this.questionState) {
        case QUESTION_STATE_START:
        case QUESTION_STATE_START_AUDIO:
          break;
        case QUESTION_STATE_PAUSE:
          if (!this.showAllAnswer) {
            if (!this.showPinchInAct) {
              return;
            }
          }
          break;
        default:
          return;
      }

      if (this.currentActIndex == index) {
        // 音声認識を停止
        this.listenForPhrasesStop();

        if (!this.showAllAnswer) {
          // 拡大表示中はstateを変えない
          if (!this.showPinchInAct) {
            this.questionState = QUESTION_STATE_START_AUDIO;
          }
        }
      } else {
        this.isActAudioPlay = true;
      }

      this.audioPlay(sound);
    },
    /**
     * 表示テキスト情報取得
     * @returns {default.methods.getTextObj.ret}
     */
    getTextObj: function(act) {
      return this.getTextObjByScriptID(act.texts, this.productLanguage, this.scriptType, this.displayMode, this.scriptSystems.default);
    },
    /**
     * ピンチインボタン押下時の処理
     */
    clickPinchInQue: function(text) {
      this.log("Milestone start clickPinchInQue");

      switch (this.questionState) {
        case QUESTION_STATE_START:
        case QUESTION_STATE_START_AUDIO:
          this.isShowPinchInQue = true;
          this.pinchInText = text;

          this.log("Milestone clickPinchInQue: set lessonState: " + storeConstants.LESSON_STATE_PAUSE);
          this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);
          break;
        default:
          break;
      }
    },
    /**
     * ピンチアウト押下通知を受け取る
     */
    recievePinchOut: function() {
      this.log("Milestone start recievePinchOut");

      this.isShowPinchInQue = false;

      if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
        // state更新して、レッスンを再開
        this.log("Milestone recievePinchOut: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
      }
    },
    /**
     * ピンチインACTアウト押下通知を受け取る
     */
    recievePinchActOut: function() {
      // 再生中の音声停止
      this.audioPause();

      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
    },
    /**
     * 長押しイベント開始
     * @param String text 拡大表示するテキスト
     */
    onTouchStart: function(text) {
      var self = this;
      this.touchTimer = setTimeout(function() {
        self.clickPinchInQue(text);
      }, constants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      clearTimeout(this.touchTimer);
    },
    /**
     * カード領域自動サイズ調整処理
     */
    autoAdjustCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let selector = this.autoAdjustSelector;

      let clones = {};
      const cloneCard = function(targetText) {
        // カードを複製
        clones.card = $(".card-inner > .swiper-slide:has(.card-multi):first").clone();
        let baseClone = clones.card.children("div").children(".card-multi").children("div");
        baseClone.children(".item").children(selector.area).children("span").html(targetText);
        clones.textArea = baseClone.children(selector.type).children(selector.area).first();
        clones.text = clones.textArea.children("span");
        clones.card.appendTo(".card-inner");
      };

      // 対象となるテキストを取得する
      let targetTexts = this.getAllBasicTexts(this.pathstep.acts, this.productLanguage, this.scriptType, this.scriptSystems.default, false);
      if (this.sreUse == "false") {
        let tileTexts = this.getTileTexts(this.productLanguage, this.scriptSystems.default);
        const push = Array.prototype.push;
        for (let displayMode in targetTexts) {
          push.apply(targetTexts[displayMode], tileTexts[displayMode]);
        }
      }

      // サイズを確定させる
      this.fixCardAreaSize(targetTexts, cloneCard, clones);
    },
    /**
     * カード領域サイズ適用
     */
    applyCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 適用サイズ取得
      let fixedHeight = this.cardAreaHeight[this.displayMode];
      let fixedFontSize = this.cardAreaFontSize[this.displayMode];
      // 確定した高さとフォントサイズを設定
      let textArea = $(".card-inner > .swiper-slide > div > .card-multi > div > .item > " + this.autoAdjustSelector.area);
      textArea.height(fixedHeight);
      textArea.css({ fontSize: fixedFontSize });
      this.tileSize = fixedFontSize;
      // 出題文表示領域を調整する
      let topArea = $(".toparea-group");
      let rootHeight = this.getComputedStyleHeight(".root");
      let headerHeight = this.getComputedStyleHeight(".header");
      let footerHeight = this.getComputedStyleHeight(".sp-second-header");
      let cardsContainerHeight = this.getComputedStyleHeight(".cards-container");
      let topAreaPaddingTop = parseInt(topArea.css("padding-top"), 10);
      topArea.height(rootHeight - headerHeight - footerHeight - cardsContainerHeight - topAreaPaddingTop);
      $(".toparea-text").css({ fontSize: fixedFontSize });
    }
  },
  created: function() {
    this.log("Milestone start created");

    // 表示用グループ分け
    this.createGroupForSwiper();

    this.setShowAnswer(this.sreUse, 0);

    // 拡大表示ボタン表示フラグ
    this.showPinchInBtn = this.isShowPinchInBtn(this.productLanguage, this.displayMode);
  },
  mounted: function() {
    this.log("Milestone start mounted");

    // スライダーの準備
    this.initSwiper();

    // 自動調整初期処理
    this.initAutoAdjust([".toparea-text", ".cards-container"], [".page-content"]);
  },
  beforeDestroy: function() {
    this.log("Milestone start beforeDestroy");

    this.$store.dispatch("setMilestoneGroupLength", 0);
    this.$store.dispatch("setMilestoneGroupIndex", 0);

    this.audioPause();
    this.listenForPhrasesStop();
    this.swiper.destroy();
    clearTimeout(this.timeoutid);
  },
  watch: {
    /**
     * 全解答表示を監視
     */
    showAllAnswer: function(newstatus) {
      if (newstatus) {
        if (this.questionState == QUESTION_STATE_END_AUDIO || this.questionState == QUESTION_STATE_END) {
          // 何もしない
        } else {
          this.questionState = QUESTION_STATE_PAUSE;
        }

        this.showSre = false;
        this.showTile = false;
        this.audioPause();
        this.listenForPhrasesStop();
      } else {
        if (this.questionState == QUESTION_STATE_END_AUDIO || this.questionState == QUESTION_STATE_END) {
          this.showAnswer = false;
          this.nextQuestion(true);
        } else {
          this.restartQuestion();
        }
      }
    },
    /**
     * レッスン状態を監視
     */
    lessonState: function(newstatus) {
      switch (this.lessonState) {
        case storeConstants.LESSON_STATE_START:
          if (this.isInitSwiper) {
            // 出題開始
            this.question(0);
          }
          break;
        case storeConstants.LESSON_STATE_PAUSE:
          this.questionState = QUESTION_STATE_PAUSE;
          this.audioPause();
          this.listenForPhrasesStop();
          break;
        case storeConstants.LESSON_STATE_RESTART:
          // 全解答表示中、拡大表示中は何もしない
          if (this.showAllAnswer || this.showPinchInAct) {
            return;
          }

          this.isShowPinchInQue = false;
          this.restartQuestion();
          break;
        case storeConstants.LESSON_STATE_STOP:
          this.audioPause();
          this.listenForPhrasesStop();
          this.$emit("stopAct");
          break;
        default:
          break;
      }
      // 表示領域自動調整
      let funcs = [this.autoAdjustCardArea, this.applyCardAreaSize];
      this.autoAdjustFirstShown(funcs, [".page-content"]);
    },
    /**
     * SREの設定を監視
     */
    sreUse: function(newstatus) {
      this.setShowAnswer(newstatus, this.currentActIndex);
    },
    /**
     * 音声再生状態の監視
     */
    isAudioPlaying: function(newstatus) {
      if (newstatus) {
        return;
      }

      // 出題中act以外の音声再生が終了した場合、何もしない
      if (this.isActAudioPlay) {
        this.isActAudioPlay = false;
        return;
      }

      switch (this.questionState) {
        case QUESTION_STATE_INIT_AUDUO:
          var act = this.pathstep.acts[this.currentActIndex];
          switch (act.usage) {
            case 1:
              this.questionState = QUESTION_STATE_START;
              if (this.sreUse === "true") {
                // 音声認識を開始
                this.incorrectCount = 0;
                this.listenForPhrases();
              } else {
                if (act.textPolicy === "r") {
                  // 空所があるか確認
                  if (this.isTileText()) {
                    this.incorrectCount = 0;
                    return;
                  }
                }

                // 次のactへ
                this.setActState(true);
                this.questionState = QUESTION_STATE_END;
                this.nextQuestion(true);
              }
              break;
            case 0:
              this.questionState = QUESTION_STATE_END;
              this.nextQuestion(true);
              break;
            default:
              // 次のactへスライド
              this.questionState = QUESTION_STATE_END;
              this.nextQuestion(false);
              break;
          }
          break;
        case QUESTION_STATE_START_AUDIO:
          // 全解答表示中は何もしない
          if (this.showAllAnswer) {
            return;
          }

          this.questionState = QUESTION_STATE_START;

          if (this.sreUse === "true") {
            // 音声認識を再開
            this.listenForPhrases();
          }
          break;
        case QUESTION_STATE_END_AUDIO:
          // 全解答表示中は何もしない
          if (this.showAllAnswer) {
            return;
          }

          this.showAnswer = false;
          this.nextQuestion(true);
          break;
        default:
          break;
      }
    },
    /**
     * 中国語表示切り替え
     *
     * @param {String} newstatus
     */
    scriptType: function(newstatus) {
      // 表示テキスト再設定
      this.createSelectAnswerTexts(this.currentConfuserIndex);
      // 拡大表示ボタン表示フラグ
      this.showPinchInBtn = this.isShowPinchInBtn(this.productLanguage, this.displayMode);
      // 自動調整サイズ適用
      this.applyCardAreaSize();
    },
    /**
     * 表示切り替え
     *
     * @param {String} newstatus
     */
    displayMode: function(newstatus) {
      // 表示テキスト再設定
      this.createSelectAnswerTexts(this.currentConfuserIndex);
      // 拡大表示ボタン表示フラグ
      this.showPinchInBtn = this.isShowPinchInBtn(this.productLanguage, this.displayMode);
      // 自動調整サイズ適用
      this.applyCardAreaSize();
    },
    /**
     * ピンチイン表示
     */
    showPinchInAct: function(newShowPinchIn) {
      if (!newShowPinchIn) {
        // 閉じる
        this.recievePinchActOut();
      }
    },
    /**
     * ピンチイン音声再生
     */
    pinchInAudioPlayActIndex: function(newPinchInAudioPlayActIndex) {
      if (newPinchInAudioPlayActIndex !== null) {
        // オーディオ再生
        this.$store.dispatch("setPinchInAudioPlayActIndex", null);
        var sound = this.pathstep.acts[newPinchInAudioPlayActIndex].sounds[0];
        this.childAudioPlay(sound, newPinchInAudioPlayActIndex);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/style/card";

.toparea-mic {
  .item {
    width: 300px;
    word-wrap: break-word;
    white-space: normal;
    position: relative;
    cursor: default;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: $dgray;
      position: absolute;
      right: 0;
      width: 3px;
    }
    &::-webkit-scrollbar {
      width: 10px;
      background-color: $dgray;
      position: absolute;
      right: 0;
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: $dgray;
      border: 2px solid $dgray;
      position: absolute;
      right: 0;
      width: 3px;
    }

    .mic-icon {
      z-index: 2;
      background: url(#{$imgpath}mic/mic_base.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
      margin: 5px 0;
    }
    .mic-icon.score_1 {
      background: url(#{$imgpath}mic/mic_01.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_2 {
      background: url(#{$imgpath}mic/mic_02.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_3 {
      background: url(#{$imgpath}mic/mic_03.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_4 {
      background: url(#{$imgpath}mic/mic_04.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_5 {
      background: url(#{$imgpath}mic/mic_05.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_6 {
      background: url(#{$imgpath}mic/mic_06.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_7 {
      background: url(#{$imgpath}mic/mic_07.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_8 {
      background: url(#{$imgpath}mic/mic_08.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_9 {
      background: url(#{$imgpath}mic/mic_09.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_10 {
      background: url(#{$imgpath}mic/mic_10.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
  }
}
//====================
//  column separate card for milestone
//====================
.inner.milestone {
  width: 100% !important;
  max-width: 100%;
  .toparea-group {
    height: 140px;
    width: 100%;
  }
  .swiper-milestone.swiper-container-horizontal {
    width: 100% !important;
  }
  .swiper-slide {
    width: auto !important;
    height: 500px !important;
    @include display(flex);
    @include align-items(flex-end);
    @include justify-content(center);
  }
  .card-single {
    width: 420px;
  }
  .card-multi {
    width: 840px;
    .item {
      &:first-child {
        margin-right: 5px;
      }
      &:last-child {
        margin-left: 5px;
      }
    }
  }
  .card-inner {
    .item {
      width: auto !important;
      max-width: 420px;
      height: auto !important;
      padding: 0.5rem;
      background: $white;
      border-radius: $base-border-radius;
      div {
        width: 100%;
      }
      p {
        height: 70px;
        margin: 0 auto;
        width: 100%;
      }
      .card {
        width: 400px;
        height: 400px;
        position: relative;
      }
      .image {
        width: 400px;
        height: 400px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.milestone {
  .input {
    border: solid 1px #bfbfbf;
    background: #d7dee1;
    display: inline-block;
    margin-right: 3px;
    margin-left: 3px;
    + .input {
      margin-left: 0;
    }
    .propSp & {
      width: 30px;
    }
  }
  @for $i from 10 through 81 {
    .font#{$i} {
      .input {
        height: 1px * $i;
        @if $i <= 14 {
          width: 15px;
        } @else if $i <= 17 {
          width: 20px;
        } @else if $i <= 20 {
          width: 30px;
        } @else {
          width: 40px;
        }
      }
    }
  }
}
.pinch-in-card {
  .input {
    border: solid 1px #bfbfbf;
    background: #d7dee1;
    display: inline-block;
    margin-right: 3px;
    margin-left: 3px;
    + .input {
      margin-left: 0;
    }
  }
  @for $i from 10 through 81 {
    .font#{$i} {
      .input {
        height: 1px * $i;
        @if $i <= 14 {
          width: 15px;
        } @else if $i <= 17 {
          width: 20px;
        } @else if $i <= 20 {
          width: 30px;
        } @else {
          width: 40px;
        }
      }
    }
  }
}
.propSp {
  .milestone {
    .input,
    .input-active {
      height: var(--tileHeight);
      width: var(--tileWidth);
    }
  }
}
</style>



// WEBPACK FOOTER //
// Milestone.vue?38fae8da